import React from 'react';

const CellSVG = ({
  fill
}) => (
  <svg width="90px" height="45px" viewBox="428 83 90 45">
    <path d="M428,90.2816123 C445.877771,80.4578529 500.541833,80.6884233 518,90.2816123 L497.31127,128 C476.454925,122.368434 474.046512,121.440833 448.68873,128 L428,90.2816123 Z" fill={fill}></path>
  </svg>
)

export default CellSVG;




// WEBPACK FOOTER //
// ./src/assets/svg/cell.js